import { useCart } from "../lib/cart";
import { ShoppingBag } from "lucide-react";

export default function StickyCartBar({ onOpen }) {
  const { count, subtotal } = useCart();
  if (count === 0) return null;
  return (
    <div className="fixed bottom-3 left-3 right-3 sm:left-6 sm:right-6 lg:left-auto lg:right-6 lg:w-96 z-30 animate-fade-up">
      <button
        data-testid="sticky-cart-btn"
        onClick={onOpen}
        className="w-full mlobox-gradient text-white rounded-2xl py-4 px-5 shadow-xl shadow-orange-300/40 flex items-center justify-between hover:brightness-110 transition-all"
      >
        <div className="flex items-center gap-3">
          <div className="relative bg-white/20 rounded-xl p-2">
            <ShoppingBag size={18} />
            <span className="absolute -top-1.5 -right-1.5 bg-white text-[#CC1A00] text-[11px] font-bold rounded-full h-5 min-w-5 px-1 grid place-items-center">{count}</span>
          </div>
          <div className="text-left">
            <div className="text-xs text-white/80 font-medium">View cart &amp; checkout</div>
            <div className="text-sm font-bold">{count} item{count > 1 ? "s" : ""}</div>
          </div>
        </div>
        <div className="font-extrabold">KSh {subtotal}</div>
      </button>
    </div>
  );
}
